
    
document.addEventListener('DOMContentLoaded', function() {

    if (document.querySelectorAll('cus-pincode-checker').length > 0) {

        document.getElementById('submitButton').addEventListener('click', async function(e) {
            e.preventDefault();
            const inputField = document.getElementById('PostalCode');
            const zip = inputField.value.trim().toUpperCase();
            const successBox = document.getElementById('successDelivery');
            const noDeliveryBox = document.getElementById('noDelivery');
            const dateSpan = document.querySelector('.updated_date');
            const buttonText = document.getElementById('buttonText');

            successBox.style.display = 'none';
            noDeliveryBox.style.display = 'none';
            if (!zip) return;

            buttonText.innerText = "Checking...";

            try {
                if (/^\d{6}$/.test(zip)) {
                    const indResp = await fetch(`https://api.postalpincode.in/pincode/${zip}`);
                    const indData = await indResp.json();
                    if (indData[0].Status === "Success") {
                        return showSuccess("5-7 Days");
                    } else {
                        return showError("No delivery available on this postal code");
                    }
                }

                if (/^\d{5}$/.test(zip)) {
                    const usResp = await fetch(`https://api.zippopotam.us/us/${zip}`);
                    if (usResp.ok) {
                        return showSuccess("7-9 Days");
                    } else {
                        return showError("No delivery available on this postal code");
                    }
                }

                if (/^\d{4}$/.test(zip)) {
                    return showSuccess("7-9 Days");
                }

                const isAlphanumeric = /^(?:[A-Z]{1,2}\d[A-Z\d]? ?\d[A-Z]{2}|[A-Z]\d[A-Z] ?\d[A-Z]\d)$/.test(zip);
                if (isAlphanumeric) {
                    return showSuccess("7-9 Days");
                }

                showError("Invalid code");

            } catch (error) {
                showError("Invalid code");
            } finally {
                buttonText.innerText = "Check";
            }

            function showSuccess(days) {
                dateSpan.innerText = days;
                successBox.style.display = 'block';
            }
            function showError(msg) {
                noDeliveryBox.innerText = msg;
                noDeliveryBox.style.display = 'block';
            }
        });
    }

        
    const sliderThumbs = new Swiper(".swiper-container.product-thumbials_slider", {
        slidesPerView: 5,
        spaceBetween: 3.28,
        freeMode: true,
        breakpoints: {
          0: {direction: "horizontal"},
          768: {direction: "horizontal"}
        },
        scrollbar: {el: '.swiper-scrollbar',draggable: true,snapOnRelease: false},
    });
    const sliderImages = new Swiper(".product-image-slider", {
        slidesPerView: 1,
        spaceBetween: 0,
        mousewheel: false,
        grabCursor: true,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        thumbs: {
            swiper: sliderThumbs
        },
        breakpoints: {
            0: {
                direction: "horizontal",
                slidesPerView: 1.179,
                spaceBetween: 2.55
            },
            750: {
                direction: "horizontal"
            }
        },
        on: {
            slideChange: function() {
                var getindex = sliderImages.activeIndex;
                var videopause = document.querySelectorAll('.product-image-slider .swiper-wrapper .inner_pdp_slider-rpeater video');
                videopause.forEach(function(videpaused) {
                    videpaused.pause();
                });
                var video_exist = document.querySelector(".product-image-slider .swiper-wrapper .inner_pdp_slider-rpeater[dataindex='" + getindex + "'] video");
                if (video_exist) {
                    document.querySelector(".product-image-slider .swiper-wrapper .inner_pdp_slider-rpeater[dataindex='" + getindex + "'] video").play();
                }
            }
        }
    });

    document.querySelectorAll(".tabs_title_rpeater").forEach(function(tabTitle) {
        tabTitle.addEventListener("click", function() {
            document.querySelectorAll(".tabs_title_rpeater").forEach(function(tab) {
                tab.classList.remove("active");
            });
            this.classList.add("active");
            var get_handle = this.getAttribute("data-handle");
            document.querySelectorAll(".tabs_all_content-wrapp .tabs_inner_content-rpeater").forEach(function(tabContent) {
                tabContent.style.display = "none";
            });
            var tabContentToShow = document.querySelector(".tabs_all_content-wrapp .tabs_inner_content-rpeater[data-handle='" + get_handle + "']");
            if (tabContentToShow) {
                tabContentToShow.style.display = "block";
            }
        });
    });

    var accordionTitles = document.querySelectorAll(".accordion_title_rpeater");
    accordionTitles.forEach(function(title) {
        title.addEventListener("click", function() {
            var parentWrapper = this.closest(".accordions_content-title-wrapp");
            var innerContent = parentWrapper.querySelector(".accordion_inner_content-rpeater");
            var isActive = parentWrapper.classList.contains("active");
            var innerContents = document.querySelectorAll(".accordions_content-title-wrapp .accordion_inner_content-rpeater");
            innerContents.forEach(function(content) {
                content.style.display = "none";
            });
            var accordionWrappers = document.querySelectorAll(".accordions_content-title-wrapp");
            accordionWrappers.forEach(function(wrapper) {
                wrapper.classList.remove("active");
            });
            if (!isActive) {
                parentWrapper.classList.add("active");
                innerContent.style.display = "block";
            }
        });
    });
    var sizeChartPopup = document.querySelector('.size_chart_popup-wrapp');
    if (sizeChartPopup) {
        document.querySelectorAll('.size_chart_popup-wrapp .custom-sizecart-wrapper p').forEach(function(element) {
            element.addEventListener('click', function() {
                var parent = this.closest('body');
                var sizeChart = parent.querySelector('.ProductSize_Chart');
                if (sizeChart) {
                    var body = document.body;
                    sizeChart.style.display = 'block';
                    body.classList.add("sizechartopen");
                }
            });
        });
        document.querySelector('.sizechart-cross-btn').addEventListener('click', function() {
            var sizeChart = document.querySelector('.ProductSize_Chart');
            if (sizeChart) {
                var body = document.body;
                sizeChart.style.display = 'none';
                body.classList.remove("sizechartopen");
            }
        });
    }
  var mySwiper = new Swiper(".new-complementry-slider", {
    spaceBetween: 6,
    slidesPerView: 4,
    loop: false,
    pagination: false,
    navigation: {
        nextEl: '.complementry-swiper-button-next',
        prevEl: '.complementry-swiper-button-prev',
    },
    breakpoints: {
        0: {
            slidesPerView: 2,
            spaceBetween: 6,
        },
        750: {
            slidesPerView: 2.2,
            spaceBetween: 6,
        },
        990: {
            slidesPerView: 4,
            spaceBetween: 6,
        }
    }
});
});

function getRecentPdp() {
    const pdpData = JSON.parse(localStorage.getItem('recently_viewed'));
    const recentViewHtml = []

    pdpData.forEach(function(item) {
        recentViewHtml.push(`
        <div class="size_popup-parent recently-custom_grid__item  swiper-slide">
        <div class="card-wrapper product-card-wrapper underline-links-hover">
        <div class="card card--standard card--media" style="--ratio-percent: 100%;">
            <div class="recently-viewd-cardwrapp card__inner color-scheme-2 gradient ratio" style="--ratio-percent: 100%;">
            <a href="${item.productUrl}">
            <div class="media media--transparent media--hover-effect">
            <img src='${item.productImg}' class="motion-reduce" />
             ${item.secondimg}
            </div>
            </a>
             <div class="wishlist_hero_wishlist-wrapp">
            <div data-wlh-id='${item.proid}' data-wlh-link='${item.productUrl}?variant=${item.firstvarid}' data-wlh-variantid='${item.firstvarid}' data-wlh-price='${item.productpricesimple}' data-wlh-name='${item.productTitle}' data-wlh-image='${item.productImg}' data-wlh-view="Collection" class="wishlist-hero-custom-button wishlisthero-floating" data-wlh-mode="icon_only"></div>
           </div>
                                                         <div class="image_upper_cartbtn btn medium-hide large-up-hide">
                    <input name="id" class="ATCtext" data_id='${item.proid}' type="hidden" />             
                    <div class="product_upper_cart-trigger btn"><svg class="addto-cart-icon btn" xmlns="http://www.w3.org/2000/svg" width="24" height="23" viewBox="0 0 24 23" fill="none">
<ellipse cx="11.994" cy="11.5969" rx="11.5269" ry="11.1774" fill="white"/></ellipse>
<path d="M12.0589 7.53223L12.0589 15.7906" stroke="#5E5E5E" stroke-width="0.75" stroke-linecap="round"/></path>
<path d="M16.319 11.6616L7.80235 11.6616" stroke="#5E5E5E" stroke-width="0.75" stroke-linecap="round"/></path>
</svg></div>
                  </div>  
                  ${item.prooption}
            </div>
            <div class="card__content">
             <div class="card__information">
             <div class="MainCArt_info">
            <h3 class="card__heading h5">
                <a class="full-unstyled-link" href="${item.productUrl}">
                ${item.productTitle}
                </a>
            </h3>
            <div class="BriefDEscription" bis_skin_checked="1">${item.metadesc}</div>
            </div>
            <p class="c-productPrice"><span class="mrp-text">MRP </span> ${item.productPrice}</p>
            </div>
             </div>
        </div>
        
        </div>
        </div>
    `)
    })
    const recentBlock = `${recentViewHtml.join('')}`
    const contentBlock = document.querySelectorAll('.js-recentPdpBlock');
    contentBlock.forEach(element => {
        element.innerHTML = recentBlock;
    })
    var mySwiper = new Swiper('.recently-product-slider.swiper-container', {
        freeMode: false,
        slidesPerView: 4,
        loop: false,
        spaceBetween: 3,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        breakpoints: {
            1025: {
                slidesPerView: 4,
                loop: false,
                spaceBetween: 3
            },
            750: {
                slidesPerView: 3,
                loop: false,
                spaceBetween: 3
            },
            320: {
                slidesPerView: 2,
                centeredSlides: false,
                roundLengths: true,
                loop: false,
                spaceBetween: 3
            }
        }
    });
    document.querySelectorAll('.image_upper_cartbtn .product_upper_cart-trigger svg').forEach(function(svg) {
        svg.addEventListener('click', function() {
            var sizePopupParent = this.closest('.size_popup-parent');
            if (sizePopupParent) {
                var productListingSizesPopup = sizePopupParent.querySelector('.product_listing_sizes-popup');
                if (productListingSizesPopup) {
                    productListingSizesPopup.classList.add('show_popup');
                }
            }
        });
    });
    document.querySelectorAll('.listing-popup_cross_btn svg').forEach(function(svg) {
        svg.addEventListener('click', function() {
            var sizePopupParent = this.closest('.size_popup-parent');
            if (sizePopupParent) {
                var productListingSizesPopup = sizePopupParent.querySelector('.product_listing_sizes-popup');
                if (productListingSizesPopup) {
                    productListingSizesPopup.classList.remove('show_popup');
                }
            }
        });
    });
    setTimeout(function() {
        var wishlist_icon = document.querySelectorAll('.size_popup-parent .wishlist-hero-custom-button.wishlisthero-floating button');
        wishlist_icon.forEach(function(wishlist) {
            wishlist.innerHTML = '<svg width="22" height="19" viewBox="0 0 22 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M19.4578 2.50292C18.9691 2.02645 18.3889 1.64848 17.7503 1.39061C17.1117 1.13273 16.4272 1 15.7359 1C15.0446 1 14.3601 1.13273 13.7215 1.39061C13.0829 1.64848 12.5026 2.02645 12.0139 2.50292L10.9997 3.4913L9.98554 2.50292C8.99842 1.54094 7.6596 1.0005 6.26361 1.0005C4.86761 1.0005 3.52879 1.54094 2.54168 2.50292C1.55456 3.46491 1 4.76964 1 6.1301C1 7.49055 1.55456 8.79529 2.54168 9.75727L3.55588 10.7457L10.9997 18L18.4436 10.7457L19.4578 9.75727C19.9467 9.28102 20.3346 8.71557 20.5992 8.0932C20.8638 7.47084 21 6.80377 21 6.1301C21 5.45642 20.8638 4.78935 20.5992 4.16699C20.3346 3.54463 19.9467 2.97917 19.4578 2.50292Z" stroke="#313131" stroke-linecap="round" stroke-linejoin="round"/></svg>';
        });
    }, 1200);
}
getRecentPdp();
window.addEventListener("load", function() {
    checkCollageVisibility();
});
window.addEventListener("resize", function() {
    checkCollageVisibility();
});

function checkCollageVisibility() {
    var collageImages = document.querySelectorAll(".pdp_collage_main_wrapp .rpeater-pdp-collage-images");
    var visibleImages = 0;

    collageImages.forEach(function(image) {
        var computedStyle = window.getComputedStyle(image);
        if (computedStyle.display !== "none" && computedStyle.visibility !== "hidden") {
            visibleImages++;
        }
    });

    if (visibleImages === 0) {
        document.querySelector(".product-page-imagegrid-wrapp").style.display = "none";
    } else {
        document.querySelector(".product-page-imagegrid-wrapp").style.display = "block";
    }
}

function isFooterInViewport() {
    const footer = document.getElementById('footer');
    const rect = footer.getBoundingClientRect();
    return rect.top < window.innerHeight && rect.bottom >= 0;
}

function toggleButtonVisibility() {
    const button = document.getElementById('stickybtn');
    if (isFooterInViewport()) {
        button.style.display = 'none';
    } else {
        button.style.display = 'block';
    }
}

window.addEventListener('load', toggleButtonVisibility);
window.addEventListener('scroll', toggleButtonVisibility);
// function updateTexts(element) {
//     var isChecked = element.checked;
//     var inchContent = document.getElementsByClassName("MainInch_Content")[0];
//     var cmContent = document.getElementsByClassName("MainCM_Content")[0];
//     var label = document.getElementById("toggle-label");
//     if (isChecked) {
//         inchContent.style.display = "block";
//         cmContent.style.display = "none";
//         label.textContent = "Inch";
//         checkbox.value = "Inch";
//     } else {
//         inchContent.style.display = "none";
//         cmContent.style.display = "block";
//         label.textContent = "Cm";
//         checkbox.value = "Cm";
//     }
// }
document.addEventListener('click', function(event) {
    if (event.target.classList.contains('Inchestab')) {
        event.target.style.display = 'none';
        document.querySelector('.Cmtab').style.display = 'block';
        document.querySelector('.MainCM_Content').style.display = 'block';
        document.querySelector('.MainInch_Content').style.display = 'none';
    }
});
document.addEventListener('click', function(event) {
    if (event.target.classList.contains('Cmtab')) {
        event.target.style.display = 'none';
        document.querySelector('.Inchestab').style.display = 'block';
        document.querySelector('.MainInch_Content').style.display = 'block';
        document.querySelector('.MainCM_Content').style.display = 'none';
    }
});